import React, { useEffect } from 'react';
import './Profile.css';
import { FaInstagram, FaLinkedin, FaGithub } from 'react-icons/fa';
import profileImg from './assets/profile.jpeg';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Profile() {
  useEffect(() => {
    AOS.init({ duration: 1000 }); // תקופת זמן 
  }, []);

  return (
    <div className="profile-container">
      <img
        src={profileImg}
        alt="Profile"
        className="profile-img"
        data-aos="fade-down"
      />

      <h1 className="name-hover" data-aos="zoom-in">Kamal Dallasheh</h1>

      <p data-aos="fade-up" data-aos-delay="200">
        Hi, I'm Kamal Dallasheh — a passionate and dedicated Computer Science student with
        a relentless drive to grow, create, and push boundaries. Since I discovered the world of
        programming, it quickly became more than just code — it's how I express creativity and
        solve real-life problems.
        <br /><br />
        I’ve been learning and building full-stack applications using technologies like <strong>React</strong> on
        the frontend, and <strong>Node.js, Express.js, and MongoDB</strong> on the backend. Every line of
        code I write is a step closer to mastering the art of software development. I regularly
        work on side projects, explore new tools, and follow best practices to improve both my
        skills and mindset as a developer.
        <br /><br />
        But I’m not just about tech. I believe in balance — that’s why I also dedicate myself to
        fitness and discipline. As someone who trains regularly, I know how important it is to
        stay focused, push limits, and build strong habits — whether in the gym or behind the
        screen.
        <br /><br />
        I'm currently diving deeper into backend systems, database optimization, and API
        design, while sharpening my frontend user experience skills. I enjoy creating clean,
        responsive, and user-friendly interfaces that not only work great — but feel great.
        <br /><br />
        I dream of joining a high-impact software team where I can contribute, learn, and make
        a difference. Until then, I'm enjoying every bit of the journey — one commit at a time 🚀
        <br /><br />
        Feel free to explore my GitHub projects, follow my learning journey, or reach out if you
        want to connect.
      </p>

      <div
        className="social-icons"
        data-aos="fade-up"
        data-aos-delay="500"
        data-aos-once="true"
      >
        <a
          href="https://www.instagram.com/kamal_dall11"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram size={30} />
        </a>
        <a
          href="https://www.linkedin.com/in/kamal-dallasheh-a1b30b277"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaLinkedin size={30} />
        </a>
        <a
          href="https://github.com/KamalDeveloper11"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaGithub size={30} />
        </a>
      </div>

      {/* ✅ مسافة تحت الصفحة حتى ما يختفوا */}
      <div style={{ height: '100px' }}></div>
    </div>
  );
}

export default Profile;